/**
 * CustomerBill.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

 module.exports = {

  tableName: 'customer_bill',

  attributes: {

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    customer: {
      model: 'customer',
      required: true
    },

    billtype: {
      model: 'billtype',
      required: true
    },

    currency: {
      type: 'string',
      required: true,
    },

  },

};




// WEBPACK FOOTER //
// ./src/models/CustomerBill.js